import moment from "moment-timezone";

export const formatTime = (timein: string): string => {
	return moment
		.tz(timein, "MMM D, YYYY, h:mm:ss A", "Africa/Lagos")
		.tz(moment.tz.guess())
		.format("MMM D, YYYY, h:mm:ss A");
};

export const formatDate = (timein: string): string => {
	return moment
		.tz(timein, "MMM D, YYYY", "Africa/Lagos")
		.tz(moment.tz.guess())
		.format("MMM D, YYYY");
};

export const noFormatDate = (timein: string): string => {
	return moment
		.tz(timein, "MMM D, YYYY, h:mm:ss A", "Africa/Lagos")
		.format("MMM D, YYYY");
};